// lib/dashboardApi.js
import api from './api';

export const getDashboardAnalytics = async () => {
  const response = await api.get('/dashboard/analytics');
  return response.data.data;
};